import React from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'
import { mapLanguageToComponentProps } from 'admin/i18n'
import { addFile, addMessage } from 'actions'
import md5 from 'md5'
import fileServices from 'services/file'
import { FILE_SIZE_LIMIT } from 'app-constants'
import { I18nComponentType } from 'admin/i18n-types'
import styled from 'styled-components'

interface ImageInputProps {
  model: string
  i18n: I18nComponentType
  accept?: string
  dispatch: any
  imageKeys?: string[]
  imageInputRef?: React.RefObject<HTMLInputElement>
}

const InputWrapper = styled.div`
  input[type='file'] {
    display: none;
  }
`

export const ImageInputFC: React.FC<ImageInputProps> = ({
  model,
  i18n,
  dispatch,
  imageKeys,
  accept = 'image/*',
  imageInputRef,
}) => {
  const formatErrorMessage = (error: unknown) => {
    if (typeof error === 'string') {
      return error
    }
    if (error instanceof Error) {
      return error.message || error.toString()
    }
    return String(error)
  }

  const readFile = async (file: { type: string; size: number }) => {
    if (!/^image/.test(file.type)) {
      return Promise.reject(i18n.imageInput.errors.format)
    }
    if (file.size > FILE_SIZE_LIMIT) {
      return Promise.reject(i18n.imageInput.errors.size)
    }
    const dataUrl = await fileServices.readAsDataUrl(file)
    if (dataUrl.length > FILE_SIZE_LIMIT) {
      throw i18n.imageInput.errors.size
    }
    return dataUrl
  }

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event?.target?.files && event.target.files[0]

    if (file) {
      readFile(file)
        .then((url: string) => {
          const key = md5(url)
          dispatch(addFile(key, url))
          if (imageKeys) {
            dispatch(actions.change(model, [...imageKeys, key]))
          } else {
            dispatch(actions.change(model, key))
          }
          dispatch(actions.setTouched(model))
        })
        .catch((error: any) => {
          dispatch(
            addMessage({
              style: 'warning',
              text: formatErrorMessage(error),
            })
          )
        })
    }
  }

  return (
    <InputWrapper>
      <input
        id="image-input"
        type="file"
        ref={imageInputRef}
        onChange={onChange}
        accept={accept}
      />
    </InputWrapper>
  )
}

const ImageInput = connect(mapLanguageToComponentProps())(ImageInputFC)

export default ImageInput
